import React, { useState } from "react";
import backaero from "@assets/icons/backaero.png";
import SC from "./style";
import ResetPassword from "./ResetPassword";
import { apiPost } from "api/callApi";
import { Loader } from "InnoUI/components";
import { showAlert } from "utils/helper";

const ForgetPassword = ({ setCurrentView }) => {
  const [email, setEmail] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleForget = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await apiPost("/v1/forgotpasswordotp", { email });
      if (response.success === "success") {
        setShowResetPassword(true);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      showAlert({
        title: "Error",
        text: error.response?.data?.message || "An error occurred",
        icon: "error",
      });
      setLoading(false);
      setEmail("");
    }
  };

  return (
    <>
      
      {loading && <Loader />}
      {!showResetPassword ? (
        <SC.ForgetForm>
          <SC.forgetHeading>Forgot Your Password?</SC.forgetHeading>
          <SC.forgetpara>
            No worries! It happens to the best of us. Just enter your email
            address below, and we’ll send you instructions to reset your
            password.
          </SC.forgetpara>
          <SC.Form onSubmit={handleForget}>
            <SC.Label style={{ fontSize: "12px" }}>Email</SC.Label>
            <SC.TransparentInput
              type="email"
              name="email"
              placeholder="Enter your email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <SC.Button type="submit">Send OTP</SC.Button>
          </SC.Form>
          <SC.backButton>
            <span onClick={() => setCurrentView("login")}>
              <img
                src={backaero}
                alt="backaero"
                style={{ height: "10px", width: "10px", marginRight: "5px" }}
              />
              Back to Log in
            </span>
          </SC.backButton>
        </SC.ForgetForm>
      ) : (
        <ResetPassword
          email={email}
          setShowResetPassword={setShowResetPassword}
          setCurrentView={setCurrentView}
        />
      )}
    </>
  );
};

export default ForgetPassword;
